import React from 'react';
import { Box, Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';
import { StyledDialog, StyledIconButton } from '@lp/lp-ui';

interface PropTypes {
    open: boolean,
    /** Dialog heading, e.g. "Roles Guide". */
    title: string,
    handleClose: () => void,
    /** Guide body. Sections are built by the caller so each guide can use its own mix of prose, lists and tables. */
    children: React.ReactNode
}

/**
 * Shared chrome for the in-app help guides opened from the info icon in a page's title bar.
 * Holds only the dialog frame — every guide supplies its own content.
 */
export const DocDialog: React.FC<PropTypes> = ({ open, title, handleClose, children }: PropTypes) => {
    return (
        <StyledDialog open={open} maxWidth="md" fullWidth onClose={handleClose}>
            <DialogTitle variant="h3" color="primary">
                <Box display="flex" alignItems="center" py={1}>
                    {title}
                    <Box flexGrow={1} mr={2} />
                    <StyledIconButton size="small" color="error" onClick={handleClose}>
                        <Close />
                    </StyledIconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained">Close</Button>
            </DialogActions>
        </StyledDialog>
    );
};

export default DocDialog;
